import { useSelector } from "react-redux";

export default function useSecuences() {
    return useSelector(state => state.game.questions[0].dialog.sequences);
}